import React from 'react';

const ErrorPage = () => {
    return <p>An unknown error occurred. Please try again later.</p>
};

export default ErrorPage;
